// extracted by mini-css-extract-plugin
module.exports = {"item":"HowItWorksItems_item__hc1WH","item-header":"HowItWorksItems_item-header__2SNXW","how-text":"HowItWorksItems_how-text__Oa396"};